export default __webpack_public_path__ + "static/media/bloodhex.55793f3f.png";